// extracted by mini-css-extract-plugin
module.exports = {"container":"CompanyAndJobTitleIndex-module__container___25ITb","title":"CompanyAndJobTitleIndex-module__title___Zr22N","index":"CompanyAndJobTitleIndex-module__index___2LPIl"};